import { Box } from '@mui/material'
import FillrateCard from './FillrateCard'
import GoogleIcon from '../../icon/GoogleIcon'

export default function FillrateSummary({ cards = [] }) {
  return (
    <Box
      sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(240px, 22vw, 400px), 1fr))', gap: 2 }}
    >
      {cards.map(card => (
        <FillrateCard
          key={card.key}
          title={card.title}
          value={card.value}
          subtitle="Base de referencia"
          isdisabled={card.disabled}
          status={card.status}
          lines={card.lines}
          amount={card.amount}
          icon={
            <GoogleIcon
              name={card.icon}
              filled={card.iconFilled}
              size={22}
              className="oc-icon-primary"
            />
          }
        />
      ))}
    </Box>
  )
}
